/** Αποθήκευση στοιχείων σύνδεσης στον password manager — απαραίτητο σε SPA χωρίς πλήρη form navigation */
export async function saveBrowserLoginCredentials(
  username: string,
  password: string,
): Promise<void> {
  const PasswordCredentialCtor = window.PasswordCredential;
  if (!PasswordCredentialCtor || !navigator.credentials?.store) {
    return;
  }

  const trimmedUsername = username.trim();
  const trimmedPassword = password.trim();
  if (!trimmedUsername || !trimmedPassword) {
    return;
  }

  try {
    const credential = new PasswordCredentialCtor({
      id: trimmedUsername,
      password: trimmedPassword,
      name: trimmedUsername,
    });
    await navigator.credentials.store(credential);
  } catch {
    // Ο χρήστης απέρριψε ή ο browser δεν επέτρεψε αποθήκευση
  }
}
